<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div class="flex items-center gap-2">
        <time-selector v-model="startTime" :readonly="readonly" :placeholder="$t('선택')" :enable-seconds="enableSeconds" @input="onChangeTime" class="flex-1" />
        <span>~</span>
        <time-selector v-model="endTime" :readonly="readonly" :placeholder="$t('선택')" :enable-seconds="enableSeconds" @input="onChangeTime" class="flex-1" />
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="labelHidden" :columns="gridTemplateColumns">
      <div class="flex-1 flex flex-wrap items-center gap-2">
        <time-selector v-model="startTime" :readonly="readonly" :placeholder="$t('선택')" :enable-seconds="enableSeconds" @input="onChangeTime" class="w-full xl:w-128px" />
        <span>~</span>
        <time-selector v-model="endTime" :readonly="readonly" :placeholder="$t('선택')" :enable-seconds="enableSeconds" @input="onChangeTime" class="flex-1 xl:w-128px" />
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import moment from "moment";
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";

export default {
  name: "SearchTimeStartEnd",
  components: {
    TimeSelector,
    SearchFilterItem,
    SearchLabelBody,
    DateSelector,
    SearchNavItemSelect,
  },
  props: {
    label: {
      default: "",
      type: String,
    },
    enableSeconds: { type: Boolean, default: true },
    value: [String, Object],
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          st: "",
          et: "",
        };
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      const { startTime, endTime } = value;
      this.startTime = startTime;
      this.endTime = endTime;
    },
  },
  data() {
    return {
      startTime: "",
      endTime: "",
    };
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile() {
      return !(this.$store.state.verticalNavMenuWidth === "default");
    },
    initData() {
      const defaultValue = this.options && this.options["default"] ? this.options["default"] : { st: "", et: "" };
      const _query_keys = Object.keys(this.query);
      const query = this.$route.query;
      const st = query[_query_keys[0]];
      const et = query[_query_keys[1]];
      const data = {
        startTime: st || defaultValue.st,
        endTime: et || defaultValue.et,
      };
      return data;
    },
    gridTemplateColumns() {
      return this.options && this.options.gridTemplateColumns ? this.options.gridTemplateColumns : 'auto auto';
    },
    showLabelOnlyMobile() {
      return this.options && this.options.showLabelOnlyMobile ? this.options.showLabelOnlyMobile : false;
    },
    labelHidden() {
      return !(this.isMobile && this.showLabelOnlyMobile);
    },
  },
  created() {
    this.startTime = this.initData.startTime;
    this.endTime = this.initData.endTime;
    this.$emit("input", { startTime: this.startTime, endTime: this.endTime });
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    onChangeTime() {
      if (this.startTime && this.endTime) {
        const st = moment(this.startTime);
        const et = moment(this.endTime);
        const diff = st.diff(et, "days");

        if (0 < diff) {
          this.$nextTick(() => {
            this.$set(this, "startTime", et.format("YYYY-MM-DD"));
            this.$set(this, "endTime", st.format("YYYY-MM-DD"));
          });
        }
      }

      this.$emit("input", { startTime: this.startTime, endTime: this.endTime });
      this.$emit("change", { startTime: this.startTime, endTime: this.endTime });

      this.$emit("onSearch");
    },
    onClickFilterRemove () {
      this.startTime = "";
      this.endTime = "";
      this.onChangeTime();
    }
  },
};
</script>
